"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeMembers_de_de = void 0;
function backofficeMembers_de_de() {
    return {
        "backoffice.members.name": "Mitarbeiter",
        "backoffice.members.roles": "Rollen",
        "backoffice.members.companyroles": "Firmenrollen",
        "backoffice.members.projectroles": "Projektrollen",
        "backoffice.members.addrole": "Rolle hinzufügen",
        "backoffice.members.addroletext": "${name} hinzufügen",
        "backoffice.members.roleadded": "Rolle wurde hinzugefügt",
        "backoffice.members.actions": "Aktionen",
        "backoffice.members.project.members": "Projektmitarbeiter",
        "backoffice.members.project.subtitle": "Hier können den Projektmitarbeitenden spezifische Berechtigungsrollen zugewiesen werden.",
        "backoffice.members.company.members": "Firmenmitarbeiter",
        "backoffice.members.company.subtitle": "Hier können den Firmenmitarbeitenden spezifische Berechtigungsrollen zugewiesen werden."
    };
}
exports.backofficeMembers_de_de = backofficeMembers_de_de;
